import React, { useEffect, useState } from "react";
import "./About.css";
import { fetchSheetData } from "../utils/sheetUtils";
import Banner from "../assets/about-banner.jpg"
const About = () => {
  const [milestones, setMilestones] = useState([]);
  const [founders, setFounders] = useState([]);
  const [companyDetails, setCompanyDetails] = useState(null);

  useEffect(() => {
    fetchSheetData("milestones").then(setMilestones);
    fetchSheetData("founders").then(setFounders);
    fetchSheetData("companyDetails").then(data => setCompanyDetails(data[0]));
  }, []);

  return (
    <div className="about-container">
      {/* Page Banner */}
      <section className="page-banner">
        <h1>About Single Tap</h1>
      </section>

      {/* Section 1: Image + Intro */}
      <section className="intro-section">
        <img src={Banner} alt="About" />
        <div className="intro-text">
          <p>Single Tap Assistance is a modern travel service simplifying trips across India. With curated plans and seamless bookings, we help you explore hassle-free.</p>
          <p>Our mission is to offer all-in-one travel solutions, saving you time and money while ensuring the best experience.</p>
        </div>
      </section>

      {/* Section 2: Mission & Vision Cards */}
      <section className="mv-section">
        <div className="mv-card">
          <h2>Our Mission</h2>
          <p>To deliver end-to-end travel solutions in just a single tap.</p>
        </div>
        <div className="mv-card">
          <h2>Our Vision</h2>
          <p>To become India's most trusted all-in-one travel assistant.</p>
        </div>
      </section>

      {/* Section 3: Milestones */}
      <section className="milestone-section">
        <h2>Why US?</h2>
        <ul>
          {milestones.map((item, index) => (
            <li key={index}>{item.title}</li>
          ))}
        </ul>
      </section>

      {/* Section 4: Founders */}
      {/* <section className="founders-section">
        <div><h2>The Founder</h2></div>
        
        <div className="founder-cards">
          {founders.map((f, index) => (
            <div className="founder-card" key={index}>
              <h3>{f.name}</h3>
              <h4>{f.role}</h4>
              <p>{f.description}</p>
              <a href={f.linkedin} target="_blank" rel="noopener noreferrer">Connect</a>
            </div>
          ))}
        </div>
      </section> */}

      {/* Section 5: Company Details */}
      {companyDetails && (
        <section className="company-details">
          <h2>{companyDetails.heading}</h2>
          <h4>{companyDetails.subheading}</h4>
          <ul>
            {[...Array(5)].map((_, i) => {
              const point = companyDetails[`point${i + 1}`];
              return point && <li key={i}>{point}</li>;
            })}
          </ul>
        </section>
      )}
    </div>
  );
};

export default About;
